import { HttpClient } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { WithClientsResult } from '../../../features/linking-with-clients/models/with-clients-result.interface'
import { BasicResult } from '../../models/interfaces/basic-result.interface'
import { BasicSearchFields } from '../../models/interfaces/basic-search-fields.interface'
import { ConfigService } from '../../services/config.service'
import { LogService } from '../../services/log.service'

@Injectable({ providedIn: 'root' })
export class WithClientsService {
   private readonly _cn = this.constructor.name
   private readonly _httpClient = inject(HttpClient)
   private readonly _logService = inject(LogService)
   private readonly _configService = inject(ConfigService)

   searchWithClientsData(request: BasicSearchFields): Observable<BasicResult<BasicSearchFields, WithClientsResult>> {
      this._logService.info(this._cn, this.searchWithClientsData.name, this._logService.START)
      this._logService.debug(this._cn, this.searchWithClientsData.name, 'search fields:', request)
      return this._httpClient.post<BasicResult<BasicSearchFields, WithClientsResult>>(
         `${this._configService.old_BE_ApiUrl}` + `/proposedProjects/search`,
         request
      )
   }

   getWithClientsDataByID(id: number): Observable<WithClientsResult> {
      this._logService.info(this._cn, this.getWithClientsDataByID.name, this._logService.START)
      this._logService.debug(this._cn, this.getWithClientsDataByID.name, 'request id:', id)
      return this._httpClient.get<WithClientsResult>(`${this._configService.old_BE_ApiUrl}` + `/proposedProjects/${id}`)
   }

   markWithClientsDataAsProcessed(id: number) {
      this._logService.info(this._cn, this.markWithClientsDataAsProcessed.name, this._logService.START)
      this._logService.debug(this._cn, this.markWithClientsDataAsProcessed.name, 'mark as processed WithClients item id:', id)
      return this._httpClient.put(`${this._configService.old_BE_ApiUrl}` + `/proposedProjects/${id}/updateProcessed?processed=true`, {})
   }

   deleteWithClientsData(id: number) {
      this._logService.info(this._cn, this.deleteWithClientsData.name, this._logService.START)
      this._logService.debug(this._cn, this.deleteWithClientsData.name, 'deleting item with id:', id)
      return this._httpClient.delete(`${this._configService.old_BE_ApiUrl}` + `/proposedProjects/${id}`)
   }
}
